/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ThermometerSun = [
  ["path", { d: "M12 2v2" }],
  ["path", { d: "M12 8a4 4 0 0 0-1.645 7.647" }],
  ["path", { d: "M2 12h2" }],
  ["path", { d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z" }],
  ["path", { d: "m4.93 4.93 1.41 1.41" }],
  ["path", { d: "m6.34 17.66-1.41 1.41" }]
];

export { ThermometerSun as default };
//# sourceMappingURL=thermometer-sun.js.map
